import { Component, OnDestroy, OnInit } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { DataStorageService } from "assurcard-angular-library";
import { combineLatest, Observable, Subscription } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { filterNullOrUndefined } from "src/app/@operators/filter-null-or-undefined";
import { RefLanguageDto } from "src/app/api/models";
import { keepAlive } from "src/app/kiosk/state/kiosk.actions";
import { AppState, getState } from "src/app/state/app.state";
import { environment } from "src/environments/environment";
import { submitCardId, submitCardId_S4 } from "../../contract/state/contract.actions";
import { loadInsurerParams } from "../../insurer/state/insurer.actions";
import { setSelectedLanguage } from "../../transaction-info/state/transaction-info.actions";
import { getCardIdInUrl, getInsurerParamsLoaded, getSelectedInsurer } from "../../transaction-info/state/transaction-info.selectors";
import { loadLanguages } from "../state/language.actions";
import { getLangToShow, getLanguageList } from "../state/language.selectors";

@Component({
    selector: "app-select-language",
    templateUrl: "./select-language.component.html",
    styleUrls: ["./select-language.component.scss"],
    standalone: false
})
export class SelectLanguageComponent implements OnInit, OnDestroy {
	private languages$: Observable<RefLanguageDto[]> = this.store.pipe(select(getLanguageList));
	public languages: RefLanguageDto[];
	private langToShow$: Observable<string[]> = this.store.pipe(select(getLangToShow));
	private subs: Subscription[] = [];
	public langFiltered = false;
	public kioskMode = false;
	private isInsurerParamsLoaded = false;
	private state: AppState;
	constructor(private store: Store<AppState>, private dataStorage: DataStorageService) {
		if (environment.kioskMode) {
			this.subs.push(getState(this.store).subscribe(state =>{
				this.state = state;
				if (state.authentication.token == undefined || state.transactionInfo.kioskId == undefined) return;
				this.store.dispatch(keepAlive({ kioskId: state.transactionInfo.kioskId }));
			}));
		}
	}

	ngOnInit() {
		this.subs.push(this.dataStorage.remove('CURRENT_LANG').subscribe());
		
		this.kioskMode = environment.kioskMode;
		this.store.dispatch(loadLanguages());
		this.store.dispatch(setSelectedLanguage(undefined));
		this.subs.push(
			this.languages$
				.pipe(
					filterNullOrUndefined(),
					mergeMap((refLangArray) => {
						this.languages = refLangArray;
						return this.langToShow$;
					})
				)
				.pipe(filterNullOrUndefined())
				.subscribe((langToShowArray) => {
					this.langFiltered = true;
					this.languages = this.languages.filter((refLang) => langToShowArray.includes(refLang.languageCode));
				})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	onClickLanguage(language: RefLanguageDto) {
		this.subs.push(this.dataStorage.save<string>('CURRENT_LANG', language.languageCode.toUpperCase()).subscribe());

		//If card ID was in URL and insurer was already select => DO submit card ID
		this.subs.push(
			combineLatest([this.store.pipe(select(getSelectedInsurer)),
				this.store.pipe(select(getInsurerParamsLoaded)),
				this.store.pipe(select(getCardIdInUrl)),
				])
				.subscribe(([insurer, insurerParamsLoaded, cardIdInUrl]) => {
					if (insurer == null || cardIdInUrl == null ){ //NORMAL PROCESS 
						this.store.dispatch(setSelectedLanguage({ data: language }));
						return;
					}

					if (!insurerParamsLoaded)
						return;


					//When insurer Or language was set => load insurer params
					if (this.isInsurerParamsLoaded !== true) {
						this.store.dispatch(loadInsurerParams({ insurerId: insurer.insurerId, langCode: language?.languageCode }));
						this.isInsurerParamsLoaded = true;
					}
					else {
						const s4Url = environment.kioskMode ? insurer.specificKioskURL : insurer.specificHomeURL;
						this.store.dispatch(setSelectedLanguage({ data: language }));

						if (s4Url != "") {
							console.log("Sumbit language with s4Url != empty")
							this.store.dispatch(
								submitCardId_S4({
									cardNumber: cardIdInUrl,
									insurer: insurer,
									siteId: this.state?.transactionInfo?.defaultSiteId,
									hospitalNo: this.state?.transactionInfo?.defaultHospitalNo?.toString() ?? "",
									language: language,
									urls4: s4Url,
								})
							);
						}else {
							console.log("Sumbit language with s4Url == empty")
							this.store.dispatch(
								submitCardId({
									cardNumber: cardIdInUrl,
									insurer: insurer,
									siteId: this.state?.transactionInfo?.defaultSiteId,
									hospitalNo: this.state?.transactionInfo?.defaultHospitalNo?.toString() ?? "",
									language: language,
									insurerQuestionnaireId: insurer.questionnaireId,
								})
							);
						}						
					}
		}));
	}
}
